import { css } from '..'

import cera from '$fonts/cera/Cera-Pro-Regular.woff'
import ceraLight from '$fonts/cera/Cera-Pro-Light.woff'
import ceraMedium from '$fonts/cera/Cera-Pro-Medium.woff'
import ceraBold from '$fonts/cera/Cera-Pro-Bold.woff'
import cooper from '$fonts/cooper/CooperLtBTLight.woff'
import ceraWoff2 from '$fonts/cera/CeraPro-Regular.woff2'
import ceraLightWoff2 from '$fonts/cera/CeraPro-Light.woff2'
import ceraMediumWoff2 from '$fonts/cera/CeraPro-Medium.woff2'
import ceraBoldWoff2 from '$fonts/cera/CeraPro-Bold.woff2'
import cooperWoff2 from '$fonts/cooper/CooperLtBTLight.woff2'

export const fontFaces = css`
  @font-face {
    font-family: 'Cera';
    font-display: swap;
    src: url(${ceraLightWoff2}) format('woff2'), url(${ceraLight}) format('woff');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'Cera';
    font-display: swap;
    src: url(${ceraWoff2}) format('woff2'), url(${cera}) format('woff');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'Cera';
    font-display: swap;
    src: url(${ceraMediumWoff2}) format('woff2'), url(${ceraMedium}) format('woff');
    font-weight: 500;
    font-style: normal;
  }
  @font-face {
    font-family: 'Cera';
    font-display: swap;
    src: url(${ceraBoldWoff2}) format('woff2'), url(${ceraBold}) format('woff');
    font-weight: 700;
    font-style: normal;
  }
  @font-face {
    font-family: 'Cooper';
    font-display: swap;
    src: url(${cooperWoff2}) format('woff2'), url(${cooper}) format('woff');
    font-weight: 300;
    font-style: normal;
  }
`



// WEBPACK FOOTER //
// ./src/utils/theme/css/fonts.ts